import { createSlice } from "@reduxjs/toolkit";

const initialExpenseState = { expenses: [], totalExpense: 0 };

const expenseSlice = createSlice({
    name: "expense",
    initialState: initialExpenseState,
    reducers: {
        addExpenses(state, action) {
            const newExpense = action.payload;
            state.expenses.push(newExpense);
        },
        removeExpenses(state, action) {
            const existingItem = state.expenses.find((item) => item.key === action.payload);
            let updatedExpenses = [];
            let existingExpense = [...state.expenses];
            state.totalExpense = state.totalExpense - existingExpense.expense;
            for (let i = 0; i < existingExpense.length; i++) {
                if (existingExpense[i].key !== existingItem.key)
                    updatedExpenses.push(existingExpense[i]);
            }
            state.expenses = [...updatedExpenses];
        },
        getTotal(state, action) {
            const amt = (+action.payload);
            state.totalExpense = state.totalExpense + (amt);
        },
    }
});

export default expenseSlice;